<template>
  <v-container class="fill-height" fluid id="recover-password">
    <v-row>
      <login-selo>
        <template v-slot:formulario>
          <RecoverPasswordForm></RecoverPasswordForm>
        </template>
      </login-selo>
    </v-row>
  </v-container>
</template>

<script>
import LoginSelo from ".//LoginSelo.vue";
import RecoverPasswordForm from "./LostPasswordComponents/RecoverPasswordForm";

export default {
  data() {
    return {
      logo: this.$store.state.logo,
    };
  },
  components: { LoginSelo, RecoverPasswordForm },
};
</script>
<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoImg {
  width: 350px;
  margin-top: 20px;
}
</style>
